import React from 'react';

import {useTranslation} from 'react-i18next';
import {generatePath, useParams} from 'react-router-dom';

import {ProductsDetailPage} from 'components/pages/ProductsDetail';
import {ROUTE} from 'core/routes';

export const ComplaintProductDetailPage = () => {
    const {t} = useTranslation();
    const {complaintId} = useParams<{complaintId: string}>();

    return (
        <ProductsDetailPage
            backTo={generatePath(ROUTE.COMPLAINTS_DETAIL, {id: complaintId})}
            backLabel={t('pages.complaints.detail.backToComplaint')}
        />
    );
};
